import { Component, HostListener, inject, OnInit } from '@angular/core';
import { TokenService } from '@auth/services/token/token.service';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { TranslateService } from '@shared/translate/translate.service';
import { defineCustomElement as defineModal } from '@ionic/core/components/ion-modal.js';
import { defineCustomElement as defineLoading } from '@ionic/core/components/ion-loading';
import { defineCustomElement as defineToast } from '@ionic/core/components/ion-toast';
import { ColorService } from '@shared/services/theme/color.service';
import { ThemeService } from '@shared/services/theme/theme.service';
import { SplashScreen } from '@capacitor/splash-screen';
import { Capacitor } from '@capacitor/core';
import { GeolocationService } from '@shared/services/geolocation/geolocation.service';
import { Platform } from '@ionic/angular';
import { SwUpdate } from '@angular/service-worker';
import { Keyboard, KeyboardResize } from '@capacitor/keyboard';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent implements OnInit {
  private translateService = inject(TranslateService);
  private token = inject(TokenService);
  private themeService = inject(ThemeService);
  private colorService = inject(ColorService);
  private gps = inject(GeolocationService);
  private platform = inject(Platform);
  private swUpdate = inject(SwUpdate);

  constructor() {
    this.token.loadToken();
    this.translateService.initLang();
    defineModal();
    defineLoading();
    defineToast();
    this.actualizarServiceWorker();
  }

  ngOnInit(): void {
    this.themeService.initTheme();
    this.colorService.initColor();
    this.platform.ready().then(() => {
      if (this.isMobile()) {
        this.gps.requestPermission();
      }
    });
  }

  actualizarServiceWorker() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          window.location.reload();
        }
      });
    }
  }

  private isMobile(): boolean {
    return Capacitor.getPlatform() !== 'web';
  }

  onReadyStateChanged(event: any) {
    if (event.target.readyState === 'complete' && this.isMobile()) {
      SplashScreen.hide();
      // StatusBar.setStyle({ style: Style.Default });
      // StatusBar.setOverlaysWebView({ overlay: false });
      // StatusBar.setBackgroundColor({ color: '#139eaa' });
      // NavigationBar.setNavigationBarColor({
      //   color: '#139eaa',
      //   darkButtons: false,
      // });
    }
  }
}
